// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__1RHRO","label":"Checkbox_label__lzFam","wrapperDisabled":"Checkbox_wrapperDisabled__mRB22","error":"Checkbox_error__qY1AM"};